import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=f854a506&"
import script from "./TitleScreen.vue?vue&type=script&lang=js&"
export * from "./TitleScreen.vue?vue&type=script&lang=js&"
import style0 from "./TitleScreen.vue?vue&type=style&index=0&id=f854a506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports